import { useState } from 'react'
import { Button, TypographyV2 } from '@which/seatbelt'
import { ChevronLeftIcon, CrossIcon } from '@which/seatbelt/src/components/Icons'

import classnames from 'classnames'

import styles from './LaptopHelperNavigation.module.scss'
import { useLaptopHelperNavigation } from './useLaptopHelperNavigation'

type LaptopHelperNavigationProps = {
  handleClose: () => void
}

// eslint-disable-next-line @typescript-eslint/ban-types
export type LaptopHelperState = {}

export const LaptopHelperNavigation = ({ handleClose }: LaptopHelperNavigationProps) => {
  const navigation = useLaptopHelperNavigation()
  const [laptopHelperState, setLaptopHelperState] = useState<LaptopHelperState>({})

  const handleUpdate = (newState: Partial<LaptopHelperState>) => {
    setLaptopHelperState((prevState) => ({ ...prevState, ...newState }))
  }

  return (
    <div className={styles.root}>
      <div className={styles.topRow}>
        <button
          onClick={() => {
            if (navigation.canGoBack) {
              navigation.back()
            }
          }}
          type="button"
          title="Back"
          aria-label="back"
          aria-disabled={!navigation.canGoBack}
          disabled={!navigation.canGoBack}
          className={classnames(styles.backButton, { [styles.disabled]: !navigation.canGoBack })}
        >
          <ChevronLeftIcon />
        </button>
        <TypographyV2 textStyle="sb-text-interface-heading-medium" className={styles.title}>
          {navigation.title}
        </TypographyV2>
        <button
          onClick={handleClose}
          type="button"
          title="Close"
          aria-label="close"
          className={styles.closeButton}
        >
          <CrossIcon />
        </button>
      </div>
      <div className={styles.content}>
        {navigation.component && (
          <navigation.component laptopHelperState={laptopHelperState} onUpdate={handleUpdate} />
        )}
      </div>
      <div className={styles.bottomRow}>
        {navigation.isLastPage ? (
          <Button onClick={handleClose}>Show me alternatives</Button>
        ) : (
          <>
            <Button onClick={navigation.goToLastPage} appearance="secondary">
              See X laptops
            </Button>
            <Button onClick={navigation.next} disabled={!navigation.canGoNext}>
              Next
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
